import { Injectable } from '@angular/core';
import { environment } from '../config/environment';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InvoiceService {
  public apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getInvoices(appName='AR') {
    // this.apiUrl =  environment.apiUrl;
    return this.http.post<any>(this.apiUrl + '/dashboard/getuserbillings',{ data: appName })
      .pipe(
        map(invoices => {
          return invoices;
        })
      );
  }
}